/**
 * Job metadata was capped at 128 characters long before form types became editable - the Upload
 * page hard-coded maxlength="128" on every text input. The builder now seeds it as a real Max
 * Length; Upload still applies it to definitions saved before that.
 */
export const DEFAULT_TEXT_MAX_LENGTH = 128;

export enum FieldType {
  Text = 'text',
  Dropdown = 'dropdown',
  Checkbox = 'checkbox',
  Date = 'date',
  /** Calendar day plus time of day. Both types hold a Date; only the rendered inputs differ. */
  DateTime = 'datetime',
}

export interface FieldOption {
  label: string;
  value: string | number;
}

export interface FieldDefinition {
  key: string;
  label: string;
  type: FieldType;
  required?: boolean;
  defaultValue?: unknown;
  options?: FieldOption[];

  // Validation (captured in the builder, applied generically by buildValidators).
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  min?: number;
  max?: number;

  /** Custom error text keyed by Angular error name (e.g. 'required', 'maxlength'). */
  validationMessages?: Record<string, string>;

  /**
   * Angular DatePipe format kept on existing form definitions. Date fields now render as a
   * MatDatepicker, which formats through the DateAdapter, so this value is no longer applied
   * to the input; it is preserved only so saved definitions round-trip unchanged.
   */
  dateFormat?: string;

  // Rendering behavior.
  readOnly?: boolean;
  disabled?: boolean;

  /** When true, this field is auto-filled with the selected case's case number. */
  unique?: boolean;
  /** Role name (or case-model property name) whose value auto-fills this field on case selection. */
  referenceField?: string;
}
